import { render, staticRenderFns } from "./CorporateAnnouncements.vue?vue&type=template&id=654f1172&scoped=true"
import script from "./CorporateAnnouncements.vue?vue&type=script&lang=js"
export * from "./CorporateAnnouncements.vue?vue&type=script&lang=js"
import style0 from "./CorporateAnnouncements.vue?vue&type=style&index=0&id=654f1172&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "654f1172",
  null
  
)

export default component.exports